<div *ngIf="containerConfig" [ngStyle]="getGridListStyle" class="tile-container">
    <div *ngFor="let map of containerConfig.maps;trackBy: trackByIdentity;" [style.minHeight.px]="'198.5'" class="tile">
        <anatomic-map
            #map
            (dataUpdated)="onDataUpdated($event)"
            (selectionEvent)="onSelectionEvent($event)"
            [currentColor]="currentColor"
            [data]="data"
            [externalSegmentSelected]="selectedSegment"
            [hasTooltips]="isWithTooltip"
            [isMapSelected]="_isThisMapSelected(map)"
            [isWithViewId]="isWithViewId"
            [lowerLabel]="viewBottomLabel"
            [map]="map"
            [readOnly]="readOnly"
            [segmentLabel]="segmentLabelType"
            [upperLabel]="viewTopLabel"
            [viewSideLenght]="viewsSideLenght"
        ></anatomic-map>
    </div>
</div>
<map-legend
    (buttonClicked)="onLegendBtnClick($event)"
    (colorChanged)="onLegendSelection($event)"
    [actualColor]="currentColor"
    [buttonsConfiguration]="buttonsConf"
    [isHorizontal]="isHorizontal"
    [legend]="legendColors"
    [ngStyle]="getLegendStyle"
    [readOnly]="readOnly"
>
    <ng-content extra-buttons-before select="[extra-buttons-legend]"></ng-content>
</map-legend>
